import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../util/Rest';
// import { GLOBAL_FIELD } from "../../../constants/MicroServiceConstants";
import {FIELD_SEPERATOR} from '../../../constants/Lookup';


const initialData = {
  communicationLetterData: {},
  communicationDetails: {},
  templateLink: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  templateData: {},
  fieldSeperatorData: {},
};

const slice = createSlice({
  name: 'addCommunicationData',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },

    postLetterCommunicationData: (state, action) => {
      state.statusCode = action.payload.status;
      state.communicationLetterData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    getLetterCommunicationData: (state, action) => {
      state.communicationDetails = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    getTemplateLink: (state, action) => {
      state.templateLink = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    getTemplateData: (state, action) => {
      state.templateData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    resetStatus: (state, action) => {
      state.statusCode = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getFieldSeperatorData: (state, action) => {
      state.fieldSeperatorData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    resetData: (state, action)=>{
      state.communicationDetails ={};
    },
  },
});

export default slice.reducer;

export const {
  fetchStart,
  fetchError,
  resetMessage,
  getLetterCommunicationData,
  postLetterCommunicationData,
  getTemplateData,
  getTemplateLink,
  resetStatus,
  getFieldSeperatorData,
  resetData,
} = slice.actions;

export const postLetterCommunication = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/save/Lettercommconfig`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postLetterCommunicationData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getLetterCommunication = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/lettercommconfig/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getLetterCommunicationData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getTemplateDocumentLink = (key) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/generateUrl/${key}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getTemplateLink(data?.data));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const getTemplateDocument = (link) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(link)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getTemplateData(data?.data));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const resetCommunicationStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const resetMessageCom = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};

export const getFieldSeperator = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [FIELD_SEPERATOR],
      }),
    ])
      .then((data) => {
        if (data && data[0].status && data[0].status === 200) {
          dispatch(getFieldSeperatorData(data[0]?.data));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
